module.exports = "images/offline.386f9b72.png";